<template>
  <div
    class="flow-placeholder p-3 text-center d-flex"
    style="justify-content: space-between"
    v-if="draggablesListVirtualOffsets && !show_reduced_dayplan">

    <!-- <font-awesome-icon icon="coffee" size="2x" /> -->
    <!-- {{value.title}} -->
    <!--<div>
      value.idx: <pre>{{ value.idx }}</pre>
      draggablesListVirtualOffsets[value.idx].duration: {{ draggablesListVirtualOffsets[value.idx].duration}}
    </div>-->

    <div class="w-25 text-left">
      <font-awesome-icon icon="coffee" size="lg" />
    </div>

    <div v-if="false">
      <a href="#" @click.prevent="onRemovePlaceholder">squeeze</a>
    </div>

    <!--<strong class="d-block w-25 text-right">{{( value.to - value.from + draggablesListVirtualOffsets[value.idx].duration)| hoursMinutes}}</strong>-->
    <strong class="d-block w-25 text-right">{{( value.to - value.from )| hoursMinutes}}</strong>

    <template v-if="SHOW_DEBUG">
      <pre class="mini-pre">FROM: {{value.from * 1e3|shortTime}}<br />TO:   {{value.to ? $options.filters.shortTime( value.to * 1e3 ) : 'null'}}</pre>
    </template>

    <!-- <div class="flow-block-controls text-right"></div> -->
    <div v-if="showConnection || true" class="flow-block-string position-absolute"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true },
    draggablesListVirtualOffsets: {
      type: Object
    },
  },
  data: () => ({
    item: {}
  }),
  watch: {
    value: {
      handler(newValue) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters("dayplanner", [
      "show_reduced_dayplan",
    ]),
  },
  methods: {
    onRemovePlaceholder() {
      this.$emit('remove')
    }
  },
  components: {
  }
};
</script>

<style>
.flow-placeholder {
  border-radius: 3px;
  position: relative;
  background: #e2e2e2;
  color: #cccccc;
  margin-bottom: 25px;
  width: 100%;
  z-index: 1;
}
.flow-placeholder::after {
  /*
  background: #67696d;
  border-radius: 50%;
  bottom: -4px;
  content: "";
  display: block;
  height: 8px;
  left: 50%;
  margin: 0 0 0 -4px;
  position: absolute;
  width: 8px;
  z-index: 1;
  */
}
</style>
